export default {
  toasts: {
    load_error: 'Nie udało się załadować stawek opłat',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zapisane',
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  rates: {
    title: 'Marża przetwarzania',
    description:
      'Procent w %, plus opcjonalna kwota stała i minimalna za transakcję. „Dowolna metoda płatności” obowiązuje, gdy nie ma stawki dla konkretnej metody.',
    default: {
      inherits:
        'Nie ustawiono stawki Adyen, więc restauracje tego partnera korzystające z Adyen FoodAmigos płacą poniższą domyślną stawkę FoodAmigos. Ustawiona tu stawka ją zastępuje; stawka ustawiona dla pojedynczej restauracji nadal ma pierwszeństwo.',
      overridden:
        'Własna stawka Adyen tego partnera zastępuje poniższą domyślną stawkę FoodAmigos dla jego restauracji korzystających z Adyen FoodAmigos. Usuń ją, aby wrócić do stawki domyślnej.',
      own_adyen:
        'Ten partner przetwarza płatności na własnym koncie Adyen. Jego restauracje nie płacą opłaty za przetwarzanie, chyba że stawkę ustawiono tutaj lub dla pojedynczej restauracji.',
      master:
        'To są domyślne stawki FoodAmigos. Korzysta z nich każdy partner korzystający z Adyen FoodAmigos, który nie ma własnej stawki Adyen.',
      rows_title: 'Domyślne stawki FoodAmigos',
    },
  },
};
